import queryString from 'query-string';
import React from 'react';
import Button from '../components/core/Button';
import Wrapper from '../components/core/Wrapper';
import { useGlobalContext } from '../stores/global';
import styles from './_endUser.module.scss';

export default function LoginError() {
  const { user, dispatch } = useGlobalContext();
  const { message } = queryString.parse(window.location.search);

  const getMessage = (message: any) => {
    const decodedMsg = decodeURIComponent(message || '');

    if (decodedMsg.includes('E:email.already_registered')) {
      return 'Email ya registrado';
    }

    return 'Vuelve a intentarlo';
  };

  if (user) {
    window.location.href = '/';
    return null;
  }

  return (
    <Wrapper className={styles.wrapper} subHeader={{ title: 'Error' }}>
      <div style={{ textAlign: 'center' }}>
        <h2 className={styles.title}>Ocurrió un error</h2>
        <p className={styles.desc}>{getMessage(message)}</p>

        <Button
          spanProps={{ className: styles.btn }}
          label="INICIAR SESIÓN"
          onClick={() =>
            dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' })
          }
        />
      </div>
    </Wrapper>
  );
}
